var WDN = WDN || {};

if (typeof WDN.CartGift === "undefined") {
  WDN.CartGift = (function () {
    class wdnCartGift extends HTMLElement {
      constructor() {
        super();
      }

      updateStatus() {
        this.setAttribute("data-gift-status", this.status);
      }

      readAttrAsFloat(attr_name) {
        return parseFloat(this.getAttribute(attr_name));
      }

      readAttributes() {
        this.cartTotal = this.readAttrAsFloat("data-cart-total");
        this.threshold = this.readAttrAsFloat("data-gift-threshold");
        this.untilThreshold = this.readAttrAsFloat("data-until-threshold");
        this.untilThresholdPercentage = this.readAttrAsFloat(
          "data-threshold-progress"
        );
        this.status = this.getAttribute("data-gift-status");
        this.productId = this.getAttribute("data-gift-product");
        this.variantId = this.getAttribute("data-gift-variant");
      }

      assignNodes() {
        this.btnSubmit = this.querySelector('button[type="submit"]');
      }

      listenForSubmit() {
        this.handleSubmitClickBound = this.handleSubmitClick.bind(this);
        this.btnSubmit.addEventListener("click", this.handleSubmitClickBound);
      }

      onSubmitError(res) {
        this.remove();
      }

      onSubmit(res) {
        this.status = "added";
        this.updateStatus();
        WDN.CartDrawer.refresh();
      }

      handleSubmitClick() {
        this.btnSubmit.setAttribute("disabled", "");

        var itemToAdd = {
          id: this.variantId,
          quantity: 1,
          properties: {
            _cartGift: true,
          },
        };

        var reqBody = {};
        reqBody.items = [itemToAdd];

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(reqBody),
        })
          .then(res => res.json())
          .then(resJSON =>this.onSubmit(resJSON))
          .catch((error) => {
            this.onSubmitError(error);
          });
      }

      mount() {
        this.readAttributes();
        this.assignNodes();
        this.listenForSubmit();
      }

      disconnectedCallback() {
        this.btnSubmit.removeEventListener(
          "click",
          this.handleSubmitClickBound
        );
      }

      // Code starts here
      connectedCallback() {
        this.status;
        this.threshold;
        this.productId;
        this.variantId;
        this.untilThreshold;
        this.untilThresholdPercentage;
        this.cartTotal;
        this.addToCart;
        this.mount();
      }
    }

    customElements.define("wdn-cart-gift", wdnCartGift);

    class wdnCartGiftList extends HTMLElement {
      constructor() {
        super();
      }

      hideContainer() {
        this.giftContainer.classList.add("hidden");
      }

      init() {
        if (this.activeGiftCampaigns.length === 0) {
          this.hideContainer();
          return;
        }
      }

      connectedCallback() {
        this.giftContainer = document.querySelector("[data-gift-container]");
        this.activeGiftCampaigns = this.querySelectorAll("wdn-cart-gift");

        this.init();
      }
    }

    customElements.define("wdn-cart-giftlist", wdnCartGiftList);

    return {};
  })();
}
